import React, { useState } from 'react'
import { Button, Input } from 'reactstrap'
import ApiFetcher from 'lib/api_fetcher'

const AddNewsletterButton = ({ url }) => {
  const [email, setEmail] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [success, setSuccess] = useState(null)

  const fetchNewsletter = (url, email) => {
    setSubmitting(true)

    return new ApiFetcher({
      key: 'add_newsletter_subscription',
      endpoint: url,
      headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({ email })
    }).call()
      .then((res) => {
        if (res.success === true) {
          setSuccess(true)
          setEmail('') // limpia input
        } else {
          setSuccess(false)
        }
      })
      .catch(() => {
        setSuccess(false)
      })
      .finally(() => setSubmitting(false))  
  }

  const handleSubmit = () => {
    if (!email) return
    fetchNewsletter(url, email)
  }

  return (
    <>
      <p>
        Sign up to our Newsletter for all the latest updates and experiences:
      </p>

      <Input
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="newsletter-input my-3 p-4"
        placeholder="Email"
        style={{
          color: '#FFF',
          borderRadius: '50px',
          borderColor: 'transparent',
          background: '#6B6B6B',
          fontWeight: '500'
        }}
      />

      <Button
        onClick={handleSubmit}
        disabled={!email || submitting}
        size="lg"
        color="primary"
        className="w-100 p-3"
      >
        {submitting ? 'Sending...' : 'Subscribe'}
      </Button>

      {success === true && <p style={{ color: 'green' }}>Subscribed!</p>}
      {success === false && <p style={{ color: 'red' }}>Something went wrong</p>}
    </>
  )
}

export default AddNewsletterButton